import { render, staticRenderFns } from "./MyEduClass.vue?vue&type=template&id=4f9cbdf6"
import script from "./MyEduClass.vue?vue&type=script&lang=js"
export * from "./MyEduClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports